import { render, staticRenderFns } from "./studyDetails.vue?vue&type=template&id=4eb5963d"
import script from "./studyDetails.vue?vue&type=script&lang=js"
export * from "./studyDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports